import { Store } from "pullstate";

export const UserStore = new Store({
  user: null,
  userDoc: null,
  onboardingModal: false,
  onboardingStep: 0,
});